import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { EnviarSMSController } from "../../../../../Controllers/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaControllers";
import { AlertSuccess } from "../../../../../Tools/SweetAlerts";

interface IValidarSMSProps {
    NR_TELEFONE_RECEPTIVO_TESTE: string;
    ID_SERVICO_SMS: number;
    DS_USUARIO_SMS: string;
    DS_SENHA_SMS: string;
    DS_ID_AGRUPAMENTO: string;
    ID_CASO_COBRANCA_REGUA_CONFIG: number;

    setShow: (show: boolean) => void;
}

interface IValidarSMSFormData {
    DS_MENSAGEM: string;
    NR_TELEFONE: string;
}

export default function ValidarSMS(props: IValidarSMSProps) {
    const { register, handleSubmit, formState } =
        useForm<IValidarSMSFormData>();

    function handleValidarSMSFormSubmit(formData: IValidarSMSFormData) {
        EnviarSMSController(
            props.ID_CASO_COBRANCA_REGUA_CONFIG,
            formData.NR_TELEFONE,
            formData.DS_MENSAGEM
        ).then(() => {
            AlertSuccess("SMS enviado").then(() => {
                props.setShow(false);
            });
        });
    }

    return (
        <form onSubmit={handleSubmit(handleValidarSMSFormSubmit)}>
            <div className="form-group col-12">
                <label>Número de Telefone</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.NR_TELEFONE && "is-invalid"
                    }`}
                    type="text"
                    defaultValue={props.NR_TELEFONE_RECEPTIVO_TESTE}
                    name="NR_TELEFONE"
                    ref={register({
                        required: "Insira o número de telefone",
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.NR_TELEFONE
                        ? formState.errors.NR_TELEFONE.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12">
                <label>Mensagem</label>
                <textarea
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.DS_MENSAGEM && "is-invalid"
                    }`}
                    name=".DS_MENSAGEM"
                    ref={register({
                        required: "Insira a mensagem a enviar",
                    })}
                    style={{ resize: "none" }}
                    rows={3}
                />
                <div className="invalid-feedback">
                    {formState.errors.DS_MENSAGEM
                        ? formState.errors.DS_MENSAGEM.message
                        : ""}
                </div>
            </div>
            <div className="col-12">
                <button
                    type="submit"
                    className="btn btn-outline-success font-weight-bold col-12 justify-content-center"
                >
                    <FontAwesomeIcon icon={faEdit} size="lg" className="mr-1" />{" "}
                    Enviar
                </button>
            </div>
        </form>
    );
}
